import React from 'react'
import { Pagination } from '@mui/material'
import SpacedPaper from './typography/spaced-paper'
import { NOOP } from '@fedsim/helpers'

export function Paging ({
  boundaryCount = 2,
  size = 'large',
  shape = 'rounded',
  siblingCount = 1,
  variant = 'outlined',
  color = 'primary',
  pageNumber = 1,
  onChange = NOOP,
  count = 10
}) {
  return count > 1 ? (
    <SpacedPaper>
      <Pagination
        boundaryCount={boundaryCount}
        size={size}
        shape={shape}
        siblingCount={siblingCount}
        page={pageNumber}
        onChange={onChange}
        count={count}
        color={color}
        variant={variant}
      />
    </SpacedPaper>
  ) : null
}

export default Paging
